/**
 * @generated SignedSource<<04b44ecc2b02089c0bb7aba7aedb9087>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WhatToSeeBlocksFieldSections_whatToSee$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AddWhatToSeeBlockDialog_whatToSee">;
  readonly " $fragmentType": "WhatToSeeBlocksFieldSections_whatToSee";
};
export type WhatToSeeBlocksFieldSections_whatToSee$key = {
  readonly " $data"?: WhatToSeeBlocksFieldSections_whatToSee$data;
  readonly " $fragmentSpreads": FragmentRefs<"WhatToSeeBlocksFieldSections_whatToSee">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WhatToSeeBlocksFieldSections_whatToSee",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AddWhatToSeeBlockDialog_whatToSee"
    }
  ],
  "type": "WhatToSee",
  "abstractKey": null
};

(node as any).hash = "b2810caa9693bb0d5de2dd87fafccb8c";

export default node;
